import React from 'react';

export default function EmptyState({
  title = 'No records found',
  hint,
  icon,
  action,
  className = '',
}) {
  return (
    <div className={`text-center py-12 px-4 ${className}`}>
      {icon ? <div className="text-4xl mb-3">{icon}</div> : null}
      <p className="text-sm font-semibold text-ink-muted">{title}</p>
      {hint ? <p className="text-xs text-ink-subtle mt-1">{hint}</p> : null}
      {action ? <div className="mt-3">{action}</div> : null}
    </div>
  );
}
